import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import Assignments from './Assignments';
import * as taskActions from '../../actions/taskActions';
import * as drawerActions from '../../actions/drawerActions';
import {
  DRAWER_CONTENTS,
  INSTRUCTOR_TASK_TABS_CONSTANTS,
  ROLE,
  STUDENT_TASK_TABS_CONSTANTS,
  TASK_TABS_CONSTANTS
} from '../../const';
import CustomIcon from '../common/CustomIcon';
import TasksFilterOptions from '../classroom/TasksFilterOptions';
import { SegmentedControl } from '@netexknowledge/smart-components';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as bookActions from '../../actions/bookActions';

export class AssignmentsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectMenuOption: {
        key: TASK_TABS_CONSTANTS.IN_PROGRESS.key,
        label: TASK_TABS_CONSTANTS.IN_PROGRESS.label
      }
    };
    this.props.taskActions.setActiveTab(this.state.selectMenuOption.key);
    this.openNewFreeAssignmentDrawer = this.openNewFreeAssignmentDrawer.bind(this);
    this.renderNewFreeAssignmentButton = this.renderNewFreeAssignmentButton.bind(this);
    props.taskActions.setTasksKeywordsFilter();
  }

  static propTypes = {
    drawerActions: PropTypes.object,
    layoutSettings: PropTypes.object,
    taskActions: PropTypes.object,
    routeParams: PropTypes.object,
    datesFilter: PropTypes.object,
    keywordsFilter: PropTypes.string,
    assignmentButton: PropTypes.bool,
    inClassroom: PropTypes.bool,
    role: PropTypes.string,
    classroomActions: PropTypes.object,
    bookActions: PropTypes.object
  };

  componentDidMount() {
    const { classroomActions, idClassroom, role } = this.props;

    if (role === ROLE.INSTRUCTOR || role === ROLE.COINSTRUCTOR) {
      classroomActions.getClassroomParticipants(idClassroom);
      classroomActions.getClassroomGroups(idClassroom);
    }
  }

  openNewFreeAssignmentDrawer() {
    const { drawerActions, inClassroom, bookActions } = this.props;
    if (inClassroom) {
      // limpiamos contexto de libro para evitar isAboutContent=true por estado previo
      bookActions.setBookInfo({});
      bookActions.setActivities([]);
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.CREATE_ASSIGNMENTS_FROM_BOOK);
    }
  }

  renderNewFreeAssignmentButton() {
    const { role, assignmentButton, activeTaskTab, currentTasks, futureTasks, finishedTasks, inClassroom } = this.props;

    let show = true;
    switch (activeTaskTab) {
      case TASK_TABS_CONSTANTS.IN_PROGRESS.key:
        if (currentTasks.tasks.length <= 0) show = false;
        break;
      case TASK_TABS_CONSTANTS.FUTURE.key:
        if (futureTasks.tasks.length <= 0) show = false;
        break;
      case TASK_TABS_CONSTANTS.FINISHED.key:
        if (finishedTasks.tasks.length <= 0) show = false;
        break;
    }
    
    if (role === ROLE.INSTRUCTOR && assignmentButton && show) {
      return (
        <button id="add-task-button" className="fab-button" onClick={this.openNewFreeAssignmentDrawer}>
          <CustomIcon name="plus-button" size={24} />
        </button>
      );
    }
  }

  getAssignments(tab) {
    const { idClassroom } = this.props;

    return (
      <div style={{ maxHeight: '100%', height: '80%' }} key={`assignments-${tab.key}`}>
        <Assignments
          style={{ height: 'calc(100vh - 106px)' }}
          classroomId={idClassroom}
          tab={tab}
          handleOpenCreateTaskModal={this.openNewFreeAssignmentDrawer}
          role={this.props.role}
        />
        {this.renderNewFreeAssignmentButton()}
      </div>
    );
  }

  renderFilteredTasksPage() {
    return this.getAssignments({ key: 'FILTER_ACTIVE' });
  }

  getTabKeys = () => {
    const tabs = this.props.role === ROLE.INSTRUCTOR ? INSTRUCTOR_TASK_TABS_CONSTANTS : STUDENT_TASK_TABS_CONSTANTS;
    return Object.keys(tabs).filter(key => TASK_TABS_CONSTANTS.hasOwnProperty(key));
  };

  handleClickMenuItem = option => {
    this.setState({
      selectMenuOption: {
        key: option.value,
        label: option.name
      }
    });
    this.props.taskActions.setActiveTab(option.value);
  };

  render() {
    const { datesFilter, keywordsFilter } = this.props;
    const datesFilterApplied = datesFilter && !_.isNil(datesFilter.startDate) && !_.isNil(datesFilter.endDate);
    const filtersApplied = keywordsFilter || datesFilterApplied;
    const tabKeys = this.getTabKeys();

    return (
      <>
        <div className="tasks-filters-row">
          <div className="tasks-tabs-selector">
            {this.props.inClassroom ? (
              tabKeys.length > 1 && (
                <SegmentedControl
                  segments={tabKeys.map(key => ({ key, label: I18n.t(TASK_TABS_CONSTANTS[key].label) }))}
                  activeKey={this.state.selectMenuOption.key}
                  onChange={key => this.handleClickMenuItem({ value: key, name: I18n.t(TASK_TABS_CONSTANTS[key].label) })}
                />
              )
            ) : (
              <span className="inClassroom-label">{I18n.t(TASK_TABS_CONSTANTS.IN_PROGRESS.label)}</span>
            )}
          </div>
          <TasksFilterOptions />
        </div>
        {filtersApplied
          ? this.renderFilteredTasksPage()
          : this.getAssignments(TASK_TABS_CONSTANTS[this.state.selectMenuOption.key])}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    inClassroom: state.router.inClassroom,
    idClassroom: state.router.params.idClassroom,
    assignmentButton: state.account.configuration.assignmentButton,
    datesFilter: state.task.datesRangeFilter,
    keywordsFilter: state.task.keywordsFilter,
    layoutSettings: state.theme.layoutSettings,
    role: state.classrooms.selectedClassroom.classroom.role,
    currentTasks: state.task.currentTasks,
    futureTasks: state.task.futureTasks,
    finishedTasks: state.task.finishedTasks,
    activeTaskTab: state.task.activeTaskTab
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsContainer);
